import type { ReactNode } from "react";
import { ChevronDown, ChevronRight } from "lucide-react";

interface ZoneCardProps {
  zoneNumber: number;
  title: string;
  isActive?: boolean;
  isCollapsed?: boolean;
  onToggle?: () => void;
  children: ReactNode;
  hint?: string;
  rightSlot?: ReactNode;
}

export function ZoneCard({
  zoneNumber,
  title,
  isActive,
  isCollapsed,
  onToggle,
  children,
  hint,
  rightSlot,
}: ZoneCardProps) {
  const activeStyles = isActive
    ? "border-l-4 border-l-tide ring-2 ring-tide/30"
    : "border-l-4 border-l-transparent";

  return (
    <div
      className={`bg-paper-hi rounded-md shadow-card p-4 transition-shadow ${activeStyles}`}
    >
      <button
        type="button"
        onClick={onToggle}
        className="flex w-full items-center justify-between text-left"
        aria-expanded={!isCollapsed}
      >
        <div className="flex items-center gap-2">
          <span
            className={`font-mono uppercase tracking-wider text-[10.5px] font-medium ${
              isActive ? "text-tide" : "text-ink-5"
            }`}
          >
            Zone {zoneNumber}
          </span>
          <span className="text-[13.5px] font-medium">{title}</span>
        </div>
        <div className="flex items-center gap-2 text-ink-5">
          {rightSlot}
          {isCollapsed ? (
            <ChevronRight size={14} strokeWidth={1.8} />
          ) : (
            <ChevronDown size={14} strokeWidth={1.8} />
          )}
        </div>
      </button>

      {!isCollapsed && (
        <div className="mt-3">
          {children}
          {hint && (
            <div className="mt-2 text-[11px] text-ink-4">{hint}</div>
          )}
        </div>
      )}
    </div>
  );
}
